import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { handleApplicationSelect } from '../../../pages/manage/hierarchy/FormFixture';
import { compoenentRenderFrom } from '../../../helper/namespace';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

export default function TabTable3({marksForms}) {
  const location = useLocation()
  const handleRedirect = (formData) => {
    handleApplicationSelect(
      formData.pid,
      formData.node_mid,
      formData.lg_user_id,
      formData.lg_user_table_id,
      formData.flg_list_active,
      formData.privilege_view,
      formData.privilege_edit,
      formData.privilege_add,
      formData.privilege_delete,
      formData.owner_restriction,
      formData.user_list_restriction,
      formData.form_display_title,
      formData.form_display_order,
      formData.form_list_id,
      formData.breadcrumb,
      formData.main_table_id,
      formData.tree_main_title,
      formData.node_mid_actual,
      compoenentRenderFrom.STUDENT_PROFILES,
      formData.mcode,
      location.state
    )
  }
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Path</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {marksForms?.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
              {`${row.breadcrumb}`}
              <strong>{row.form_display_title}</strong>
              </TableCell>
              <TableCell align="right"><div className="arrowforward"><button  className="child-view-icon"  onClick={()=>handleRedirect(row)}><ArrowForwardIcon /></button></div></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
